import React, { useEffect, useState } from "react";
import $ from "jquery";
import { useNavigate } from "react-router";
import vector from "../../../assets/svg/Vector.svg";
import vectorblack from "../../../assets/svg/vectorblack.svg";
import UserRole from "../../helpers/role";
import DMSLogo from "../../../assets/svg/DMSLogo.svg";
import TMSLogo from "../../../assets/svg/TMSLogo.svg";
import GALogo from "../../../assets/svg/GALogo.svg";
import MenuIcon from "../../../assets/svg/collapse-menu.svg";
import FujitecLogo from "../../../assets/svg/Fujitec.svg";
import notify from "../../../assets/svg/notify.svg";
import logoutimage from "../../../assets/svg/Logout.svg";
import Pendingtask from "../../../assets/svg/pendingtask.svg";
import HomeActive from "../../../assets/svg/homeactive.svg";
import Home from "../../../assets/svg/home.svg";
import * as paths from "../../helpers/routerPaths";
import Pendingtaskactive from "../../../assets/svg/pendingtaskactive.svg";
import myTrainingActiveIcon from "../../../assets/svg/myTrainingActiveIcon.svg";
import myTrainingIcon from "../../../assets/svg/myTrainingIcon.svg";
import Coursecatalogue from "../../../assets/svg/coursecatalogue.svg";
import Coursecatalogueactive from "../../../assets/svg/coursecatalogueSideactive.svg";
import Coursequestionnaire from "../../../assets/svg/coursequesionside.svg";
import Coursequestionnaireactive from "../../../assets/svg/coursequestionnaireactive.svg";
import PendingapprovalsIcon from "../../../assets/svg/mypendingapprovalicon.svg";
import PendingapprovalactiveIcon from "../../../assets/svg/mypendingapprovalsideactiveicon.svg";
import Vendors from "../../../assets/svg/vendorname.svg";
import Vendorsactive from "../../../assets/svg/vendorsideactive.svg";
import masterDataIcon from "../../../assets/svg/masterdataIcon.svg";
import masterDataActiveIcon from "../../../assets/svg/masterdataactiveIcon.svg";
import skillIcon from "../../../assets/svg/skillicon.svg";
import skillActiveIcon from "../../../assets/svg/skillactiveicon.svg";
import jobicon from "../../../assets/svg/jobicon.svg";
import jobactiveicon from "../../../assets/svg/jobactiveicon.svg";
import letterundertakingIcon from "../../../assets/svg/letterundertaking.svg";
import letterundertakingIconActive from "../../../assets/svg/letterundertakingIcon.svg";
import supportingIcon from "../../../assets/svg/supportingicon.svg";
import supportingActiveIcon from "../../../assets/svg/supportingactiveicon.svg";
import Skillmatrixactive from "../../../assets/svg/skillmatrixactive.svg";
import Skillmatrix from "../../../assets/svg/skillmatrix.svg";
import skilloverview from "../../../assets/svg/skilloverview.svg";
import skilloverviewactive from "../../../assets/svg/skilloverviewactive.svg";
import UpcomingTrainingActiveIcon from "../../../assets/svg/upcomingTrainingActiveIcon.svg";
import UpcomingTrainingIcon from "../../../assets/svg/upcomingTrainingIcon.svg";
import { useDispatch } from "react-redux";
import SubCategoryIconActive from "../../../assets/svg/activesmallcategory.svg";
import SubCategoryIcon from "../../../assets/svg/smallcategory.svg";
import DownArrowIcon from "../../../assets/svg/downarrow.svg";
import UpArrowIcon from "../../../assets/svg/uparrow.svg";
import myteam from "../../../assets/svg/myteam.svg";
import myteamactive from "../../../assets/svg/myteamactive.svg";
import mySelfIcon from "../../../assets/svg/mySelfIcon.svg";
import mySelfIconActive from "../../../assets/svg/mySelfIconActive.svg";
import teamtraining from "../../../assets/svg/teamtraining.svg";
import teamtrainingActive from "../../../assets/svg/teamtrainingActive.svg";
import pteIcon from "../../../assets/svg/pteIcon.svg";
import pteActive from "../../../assets/svg/pteActive.svg";
import levelIcon from "../../../assets/svg/levelIcon.svg";
import levelActive from "../../../assets/svg/levelActive.svg";
import courseMaster from "../../../assets/svg/courseMaster.svg";
import courseMasterActive from "../../../assets/svg/courseMasterActive.svg";
import adminActive from "../../../assets/svg/adminActive.svg";
import adminIcon from "../../../assets/svg/adminIcon.svg";
import requestStatusIcon from "../../../assets/svg/requestStatusIcon.svg";
import requestStatusActiveIcon from "../../../assets/svg/requestStatusActiveIcon.svg";
import Companyside from "../../../assets/svg/Company_side.svg";
import Company_side_inActive from "../../../assets/svg/Company_side_inActive.svg";
import moment from "moment/moment";
import CommonIcon from "../../helpers/icons";
import AppLauncher from "./AppLauncher";
import axios from "axios";
import API from "../../helpers/endpointservice";
import { logoutFunction } from "../../custom/logoutFunction";
import { PulseLoader } from "react-spinners";
import noNotify from "../../../assets/img/no_notify2.png";
import swal from "sweetalert";
import { toast } from "react-toastify";
import { useCookies } from "react-cookie";

var removeClass = true;

const TopBar = () => {
  const dispatch = useDispatch();
  const [logoutLoader, setlogoutLoader] = useState(false);

  const navigate = useNavigate();
  const path = window.location.pathname;

  const [appMenu, setAppMenu] = useState(false);
  const [Role, setRole] = useState("");
  const [sideMenu, setSideMenu] = useState(false);
  const [sideMenuMob, setSideMenuMob] = useState(false);
  const [isMobile, setisMobile] = useState(false);
  const [isMobile1, setisMobile1] = useState(false);
  const [isSmallMobile, setisSmallMobile] = useState(false);
  const [logout, setLogout] = useState(false);
  const [masterdataOptions, setMasterDataOptions] = useState(false);
  const [windowHeight, setwindowHeight] = useState(0);
  const [width, setWidth] = useState(0);
  const [rightbarActive, setRightbarActive] = useState(false);
  const [mySelfOptions, setMySelfOptions] = useState(false);
  const [myTeamOptions, setMyTeamOptions] = useState(false);
  const [propertyLoader, setPropertyLoader] = useState(false);
  const [propertyFailed, setPropertyFailed] = useState(false);
  const [enterNotify, setEnterNotify] = useState(false);

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [imageTxt, setImageTxt] = useState("");

  const [cookies, setCookie, removeCookie] = useCookies("");

  const routeNavigation = (path) => {
    navigate(path);
    setSideMenuMob(!sideMenuMob);
  };

  ///////////////// Notification ////////////////////////
  const getNotifyCount = async () => {
    let userId = localStorage.getItem("UserId");

    let notifyGetApiUrl = `${API.GET_NOTIFICATION_COUNT}?userId=${userId}`;
    await axios
      .get(notifyGetApiUrl)
      .then((response) => {
        if (response?.status === 200) {
          setNotifyCount(response.data);
        }
      })
      .catch((err) => {
        logoutFunction(err?.response?.status);
        console.log(err);
      });
  };

  const getNotify = async () => {
    let userId = localStorage.getItem("UserId");

    let notifyGetApiUrl = `${API.GET_NOTIFICATIONS}?userId=${userId}`;
    await axios
      .get(notifyGetApiUrl)
      .then((response) => {
        if (response?.status === 200) {
          const sortedData = response.data
            ?.slice()
            ?.sort((a, b) => new Date(b.createdDate) - new Date(a.createdDate));
          setmessages(sortedData);
          setNotifyCount(response.data?.length);
          setPropertyLoader(false);
        }
      })
      .catch((err) => {
        setPropertyLoader(false);
        setPropertyFailed(true);
        logoutFunction(err?.response?.status);
        console.log(err);
      });
  };

  const openNotification = () => {
    if (enterNotify === false) {
      // setEnterNotify(true)
      let myOffcanvas = new window.bootstrap.Offcanvas(
        document.getElementById("NotificationScreen")
      );
      myOffcanvas.show();
      $("#overlayId").addClass("viewbar-overlay-notify");
      $("body").addClass("scrollhide");
      getNotify();
    }
  };

  const [notifyCount, setNotifyCount] = useState(0);
  //     const [messages, setmessages] = useState(
  //         [
  //       {
  //           "notificationId": 583,
  //           "documentNumber": "SIT_DOC0001 Ver 1",
  //           "documentName": "SIT testing",
  //           "body": "Reminder to Approve the document",
  //           "createdDate": "2023-06-24T07:04:36.478823+00:00",
  //           "createdTime": "13 days ago"
  //       },
  //       {
  //           "notificationId": 703,
  //           "documentNumber": "FJT0002 Ver 1",
  //           "documentName": "Jorth2",
  //           "body": "Reminder to Approve the document",
  //           "createdDate": "2023-07-03T09:42:51.420406+00:00",
  //           "createdTime": "4 days ago"
  //       },
  //       {
  //           "notificationId": 617,
  //           "documentNumber": "NEW_SIT0003 Ver 2",
  //           "documentName": "upload SIT",
  //           "body": "Reminder to Approve the document",
  //           "createdDate": "2023-06-28T06:36:47.244376+00:00",
  //           "createdTime": "9 days ago"
  //       },
  //   //   ]
  //       )
  const [messages, setmessages] = useState([]);

  const removeNotification = async (id, type) => {
    let userId = localStorage.getItem("UserId");
    setPropertyLoader(true);
    if (id) {
      if (type === "clearOne") {
        let notifyRemoveApiUrl = `${API.PUT_UPDATE_NOTIFICATION}?userId=${userId}&notificationId=${id}&isClearAll=false`;
        await axios
          .put(notifyRemoveApiUrl)
          .then((response) => {
            if (response?.status === 200) {
              if (response.data === true) {
                getNotifyCount();
                getNotify();
              }
            }
          })
          .catch((err) => {
            setPropertyLoader(false);
            logoutFunction(err?.response?.status);
            console.log(err);
            //   logoutFunction(err?.response?.status);
          });
      } else if (type === "clearAll") {
        let notifyRemoveApiUrl = `${API.PUT_UPDATE_NOTIFICATION}?userId=${userId}&isClearAll=true`;
        await axios
          .put(notifyRemoveApiUrl)
          .then((response) => {
            if (response?.status === 200) {
              if (response.data === true) {
                getNotifyCount();
                getNotify();
                // dispatch(setNotifyCountFn())
              }
            }
          })
          .catch((err) => {
            setPropertyLoader(false);
            logoutFunction(err?.response?.status);
            console.log(err);
            //   logoutFunction(err?.response?.status);
          });
      }
    }
  };
  ///////////////////  End of notification  ///////////////////////////////

  useEffect(() => {
    // localStorage.setItem("UserId", 6);
    // localStorage.setItem("Role", "admin");
    let userRole = localStorage.getItem("Role").split(",")[0];
    setRole(userRole);
    userProfile();
    getNotifyCount();
    $(document).on("click", function (event) {
      var searchInput = $(".logout-style");
      if (removeClass && event.target != searchInput[0]) {
        setLogout(false);
      }
      removeClass = true;
    });

    const intervals = setInterval(() => {
      resize();
    }, 10);
    setRightbarActive(true);
    // setPropertyLoader(true);
    setPropertyFailed(false);

    return () => clearInterval(intervals);
  }, []);

  const resize = () => {
    setwindowHeight(window.innerHeight);
    if (window.innerWidth < 850) {
      setisMobile(true);
    } else {
      setisMobile(false);
    }
    if (window.innerWidth < 430) {
      setisSmallMobile(true);
    } else {
      setisSmallMobile(false);
    }
    if (window.innerWidth < 388) {
      setisMobile1(true);
    } else {
      setisMobile1(false);
    }
    setWidth(window.innerWidth);
  };

  useEffect(() => {
    if (isMobile == false) {
      setSideMenu(false);
      setSideMenuMob(false);
      dispatch({ type: "SIDE_MENU", data: false });
    } else {
      setSideMenu(false);
      setSideMenuMob(false);
    }
  }, [isMobile]);

  const sideMenuClick = () => {
    setSideMenu(!sideMenu);
    setSideMenuMob(false);
    dispatch({ type: "SIDE_MENU", data: !sideMenu });
  };

  ///// Logout /////

  const userProfile = () => {
    // if(localStorage.getItem("userDataDecode")?.email){
    const userId = JSON.parse(localStorage.getItem("userDataDecode"))?.email;
    //  const userId = "kevin.fleming@mail.com"
    if (userId) {
      const userRaw = userId.split(/[@]/);

      const user = userRaw[0].split(/[._-]/);

      if (user.length === 1) {
        const user1 = user[0].charAt(0).toUpperCase() + user[0].slice(1);
        setFirstName(user1);
        setLastName(null);

        setImageTxt(user[0].charAt(0).toUpperCase());
      } else if (user.length > 1) {
        const user1 = user[0].charAt(0).toUpperCase() + user[0].slice(1);
        const user2 = user[1].charAt(0).toUpperCase() + user[1].slice(1);
        setFirstName(user1);
        setLastName(user2);
        setImageTxt(user[0].charAt(0).toUpperCase());
      }
    }
  };

  const openLogoutModal = () => {
    removeClass = false;
    setLogout(!logout);
  };

  // const LogoutYes = async () => {
  //     localStorage.clear();
  //     logoutDirect();
  // };

  const LogoutYes = async () => {
    let AuthData = JSON.parse(localStorage.getItem("userDataDecode"));
    const cookieOptions = {
      domain: process.env.REACT_APP_COMMON_DOMAIN,
      path: "/",
    };
    removeCookie("refreshToken", cookieOptions);
    let apiUrl = `${API.PUT_INVALID_TOKEN}?email=${AuthData?.email}&applicationName=TAS`;
    setPropertyLoader(true);
    setlogoutLoader(true);
    axios({
      method: "PUT",
      url: apiUrl,
    })
      .then((response) => {
        if (response?.status === 200) {
          // setPropertyLoader(false);
          localStorage.clear();
          logoutDirect();
        }
      })
      .catch((err) => {
        setPropertyLoader(false);
        setlogoutLoader(false);
        console.log(err);
        logoutFunction(err?.response?.status);
      });
  };

  const logoutDirect = () => {
    // window.location.href = process.env.REACT_APP_LOGOUT;
    localStorage.clear();
    const redirectUri = process.env.REACT_APP_REDIRECTURI;
    const clientId = process.env.REACT_APP_CLIENTID;
    const scope = process.env.REACT_APP_SCOPE;
    const accesstype = process.env.REACT_APP_ACCESS_TYPE;
    const prompt = process.env.REACT_APP_PROMPT;
    const authUrl =
      process.env.REACT_APP_AUTHURL +
      `?response_type=code&client_id=${clientId}&redirect_uri=${redirectUri}&scope=${scope}&access_type=${accesstype}&prompt=${"consent"}`;
    window.location.href = authUrl;
  };
  const closeNotify = () => {
    setEnterNotify(false);
    $("#NotificationScreen").removeClass("show");
    $("#overlayId").removeClass("viewbar-overlay-notify");
    $("body").removeClass("scrollhide");
    setEnterNotify(false);
  };

  const SkillProficiency = () => {
    routeNavigation(`/${paths.SKILLPROFICIENCYDURATION}`);
    // setTimeout(() => {
    //   let myOffcanvas = new window.bootstrap.Offcanvas(
    //     document.getElementById("AddScreen")
    //   );
    //   myOffcanvas.show();
    //   $("body").addClass("scrollhide");
    // }, 100);
  };

  return (
    <>
      {$("#NotificationScreen").hasClass("show") ? (
        <div
          className="viewbar-overlay-notify"
          id="overlayId"
          onClick={closeNotify}
        ></div>
      ) : (
        <></>
      )}
      {logoutLoader && (
        <div className="spinner_overlay">
          <div className="loader">
            <PulseLoader color="#D12232" size={10} speedMultiplier={1} />
          </div>
        </div>
      )}
      <table>
        <tbody>
          <tr>
            <td>
              <div
                className={`row ml-0 ${
                  isMobile1 ? "mobile-app-head" : "px-2"
                } box `}
              >
                <div className={`col-7 d-flex align-items-center pl-9`}>
                  <img
                    src={vector}
                    className="cursor-pointer"
                    onClick={() => setAppMenu(!appMenu)}
                  />
                  {isMobile == false && (
                    <img src={FujitecLogo} className="pl-20 pt-2" />
                  )}
                  <label
                    className={`${isMobile ? "pl-10" : "pl-30"} ${
                      isSmallMobile ? "mobilelabel-style" : "label-style"
                    }`}
                  >
                    {" "}
                    {isSmallMobile ? "TAS" : "Training Administration System"}
                  </label>
                </div>
                <div
                  className={`${
                    isMobile1 ? "col-5 pr-0" : "col-5"
                  } d-flex align-items-center justify-content-end `}
                >
                  <img
                    src={notify}
                    className="cursor-pointer"
                    onClick={openNotification}
                  />
                  <div
                    className="circle-small cursor-pointer"
                    onClick={openNotification}
                  >
                    {notifyCount || 0}
                  </div>
                  <div
                    className="d-flex cursor-pointer align-items-center"
                    onClick={() => {
                      removeClass = false;
                      setLogout(!logout);
                    }}
                  >
                    {isMobile == false && (
                      <label className="cursor-pointer label-user pl-20">
                        {JSON.parse(localStorage.getItem("userDataDecode"))
                          ?.name || `${firstName} ${lastName}`}
                      </label>
                    )}
                    <div
                      className="circle cursor-pointer"
                      style={{
                        marginLeft: isMobile1 ? "5px" : isMobile ? "10px" : "",
                      }}
                    >
                      {JSON.parse(
                        localStorage.getItem("userDataDecode")
                      )?.name?.charAt(0) || imageTxt}
                    </div>
                  </div>
                </div>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      {logout == true && (
        <div className="logout-style" id="logOutScreen">
          <div
            className="pt-3 pl-10 pr-2 pb-2 logout-label text-overflow"
            title={JSON.parse(localStorage.getItem("userDataDecode"))?.email}
          >
            {JSON.parse(localStorage.getItem("userDataDecode"))?.email}
          </div>
          <div
            className="pt-2 pl-10 pr-2 pb-2 cursor-pointer logout-label cursor-pointer"
            data-bs-toggle="modal"
            data-bs-target="#logoutPage"
            onClick={openLogoutModal}
          >
            <img src={logoutimage} />
            &nbsp;&nbsp;Log out
          </div>
        </div>
      )}
      {appMenu == true && (
        <AppLauncher isOpen={appMenu} setisOpen={setAppMenu} />
      )}

      {isMobile == false && (
        <>
          <div
            className={
              sideMenu == true
                ? "side-bar-menu side-scroll"
                : "side-bar side-scroll"
            }
            style={{ height: windowHeight - 1 }}
            id="ExceptNotifyScreen"
          >
            <img
              className="pl-20 pt-10 pb-10 cursor-pointer"
              src={MenuIcon}
              onClick={sideMenuClick}
            />
            <br />

            {UserRole.EMPLOYEE === Role ? (
              <>
                <div
                  className={`${
                    sideMenu == true ? "pt-p8 pb-p8" : "pt-10 pb-10"
                  } ${
                    path == `/${paths.HOME}` ? "sidebar-active pl-17" : "pl-20"
                  } d-flex cursor-pointer menuIcon`}
                  onClick={() => routeNavigation(`/${paths.HOME}`)}
                >
                  <img src={path == `/${paths.HOME}` ? HomeActive : Home} />
                  {sideMenu == false && (
                    <div
                      className={`${
                        path == `/${paths.HOME}` ? "fw-bold text-color-red" : ""
                      } pl-14 pr-20 text-overflow app-label`}
                    >
                      Home
                    </div>
                  )}
                </div>
                <div
                  className={`${
                    sideMenu == true ? "pt-p8 pb-p8" : "pt-10 pb-10"
                  } ${
                    path == `/${paths.REQUEST_STATUS}`
                      ? "sidebar-active pl-17"
                      : "pl-20"
                  } d-flex  cursor-pointer menuIcon`}
                  onClick={() => routeNavigation(`/${paths.REQUEST_STATUS}`)}
                >
                  <img
                    src={
                      path == `/${paths.REQUEST_STATUS}`
                        ? requestStatusActiveIcon
                        : requestStatusIcon
                    }
                  />
                  {sideMenu == false && (
                    <div
                      className={`${
                        path == `/${paths.REQUEST_STATUS}`
                          ? "fw-bold text-color-red"
                          : ""
                      } pl-14 pr-20 text-overflow app-label`}
                    >
                      My request status
                    </div>
                  )}
                </div>
                <div
                  className={`${
                    sideMenu == true ? "pt-p8 pb-p8" : "pt-10 pb-10"
                  } ${
                    path == `/${paths.TRAINING_CALENDER}`
                      ? "sidebar-active pl-17"
                      : "pl-20"
                  } d-flex  cursor-pointer menuIcon`}
                  onClick={() => routeNavigation(`/${paths.TRAINING_CALENDER}`)}
                >
                  <img
                    src={
                      path == `/${paths.TRAINING_CALENDER}`
                        ? Companyside
                        : Company_side_inActive
                    }
                  />
                  {sideMenu == false && (
                    <div
                      className={`${
                        path == `/${paths.TRAINING_CALENDER}`
                          ? "fw-bold text-color-red"
                          : ""
                      } pl-14 pr-20 text-overflow app-label`}
                    >
                      Company training calendar
                    </div>
                  )}
                </div>
                <div
                  className={`${
                    sideMenu == true ? "pt-p8 pb-p8" : "pt-10 pb-10"
                  } ${
                    path == `/${paths.COURSE_CATALOUGE}`
                      ? "sidebar-active pl-17"
                      : "pl-20"
                  } d-flex  cursor-pointer menuIcon`}
                  onClick={() => routeNavigation(`/${paths.COURSE_CATALOUGE}`)}
                >
                  <img
                    src={
                      path == `/${paths.COURSE_CATALOUGE}`
                        ? Coursecatalogueactive
                        : Coursecatalogue
                    }
                  />
                  {sideMenu == false && (
                    <div
                      className={`${
                        path == `/${paths.COURSE_CATALOUGE}`
                          ? "fw-bold text-color-red"
                          : ""
                      } pl-14 pr-20 text-overflow app-label`}
                    >
                      Course catalouge
                    </div>
                  )}
                </div>
                <div
                  className={`${
                    sideMenu == true ? "pt-p8 pb-p8" : "pt-10 pb-10"
                  } ${
                    path == `/${paths.SKILL_MATRIX}`
                      ? "sidebar-active pl-17"
                      : "pl-20"
                  } d-flex  cursor-pointer menuIcon`}
                  onClick={() => routeNavigation(`/${paths.SKILL_MATRIX}`)}
                >
                  <img
                    src={
                      path == `/${paths.SKILL_MATRIX}`
                        ? Skillmatrixactive
                        : Skillmatrix
                    }
                  />
                  {sideMenu == false && (
                    <div
                      className={`${
                        path == `/${paths.SKILL_MATRIX}`
                          ? "fw-bold text-color-red"
                          : ""
                      } pl-14 pr-20 text-overflow app-label`}
                    >
                      Capability chart
                    </div>
                  )}
                </div>
              </>
            ) : (
              ""
            )}

            {UserRole.EMPLOYEE != Role ? (
              sideMenu === false ? (
                <div
                  className={` pt-10 pb-10 pl-20 
                        ${
                          path == `/${paths.HOME}` ||
                          path == `/${paths.REQUEST_STATUS}` ||
                          path == `/${paths.TRAINING_RECORDS}` ||
                          path == `/${paths.UPCOMING_TRAININGS}` ||
                          path == `/${paths.SKILL_MATRIX}` ||
                          path == `/${paths.COURSE_CATALOUGE}`
                            ? "sidebar-active pl-18"
                            : "pl-20"
                        } d-flex cursor-pointer menuIcon`}
                  onClick={() => {
                    setMySelfOptions(!mySelfOptions);
                  }}
                >
                  <img
                    alt=""
                    src={
                      path == `/${paths.HOME}` ||
                      path == `/${paths.REQUEST_STATUS}` ||
                      path == `/${paths.TRAINING_RECORDS}` ||
                      path == `/${paths.UPCOMING_TRAININGS}` ||
                      path == `/${paths.SKILL_MATRIX}` ||
                      path == `/${paths.COURSE_CATALOUGE}`
                        ? mySelfIconActive
                        : mySelfIcon
                    }
                  />
                  {sideMenu == false && (
                    <div
                      className={`
                        ${
                          path == `/${paths.HOME}` ||
                          path == `/${paths.REQUEST_STATUS}` ||
                          path == `/${paths.TRAINING_RECORDS}` ||
                          path == `/${paths.UPCOMING_TRAININGS}` ||
                          path == `/${paths.SKILL_MATRIX}` ||
                          path == `/${paths.COURSE_CATALOUGE}`
                            ? "fw-bold text-color-red"
                            : ""
                        } col-5 pl-20 text-overflow app-label`}
                    >
                      Myself
                    </div>
                  )}
                  {mySelfOptions === true && sideMenu === false ? (
                    <div className="col-5 d-flex justify-content-end">
                      <img alt="" src={UpArrowIcon} className="setting-img" />
                    </div>
                  ) : mySelfOptions === false && sideMenu === false ? (
                    <div className="col-5 d-flex justify-content-end">
                      <img alt="" src={DownArrowIcon} className="setting-img" />
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
              ) : (
                <div
                  className={` pt-10 pb-10 pl-20 ${
                    path == `/${paths.HOME}` ||
                    path == `/${paths.REQUEST_STATUS}` ||
                    path == `/${paths.TRAINING_RECORDS}` ||
                    path == `/${paths.UPCOMING_TRAININGS}` ||
                    path == `/${paths.SKILL_MATRIX}` ||
                    path == `/${paths.COURSE_CATALOUGE}`
                      ? "sidebar-active pl-18"
                      : "pl-20"
                  } d-flex cursor-pointer menuIcon`}
                  onClick={sideMenuClick}
                >
                  <img
                    alt=""
                    src={
                      path == `/${paths.HOME}` ||
                      path == `/${paths.REQUEST_STATUS}` ||
                      path == `/${paths.TRAINING_RECORDS}` ||
                      path == `/${paths.UPCOMING_TRAININGS}` ||
                      path == `/${paths.SKILL_MATRIX}` ||
                      path == `/${paths.COURSE_CATALOUGE}`
                        ? mySelfIconActive
                        : mySelfIcon
                    }
                  />
                </div>
              )
            ) : (
              <></>
            )}

            {sideMenu === false && mySelfOptions === true ? (
              <>
                <div
                  className={`pt-10 pb-10 ${
                    path == `/${paths.HOME}` ? "" : ""
                  } d-flex pl-60 cursor-pointer menuIcon`}
                  onClick={() => routeNavigation(`/${paths.HOME}`)}
                >
                  <img
                    alt=""
                    src={path == `/${paths.HOME}` ? HomeActive : Home}
                  />
                  {sideMenu == false && (
                    <div
                      className={`${
                        path == `/${paths.HOME}` ? "fw-bold " : ""
                      } pl-10 pr-20 text-overflow app-label`}
                    >
                      Home
                    </div>
                  )}
                </div>
                {UserRole.ADMIN === Role || UserRole.SYSTEMADMIN === Role ? (
                  <>
                    <div
                      className={`pt-10 pb-10 ${
                        path == `/${paths.TRAINING_RECORDS}` ? "" : ""
                      } d-flex pl-60 cursor-pointer menuIcon`}
                      onClick={() =>
                        routeNavigation(`/${paths.TRAINING_RECORDS}`)
                      }
                    >
                      <img
                        alt=""
                        src={
                          path == `/${paths.TRAINING_RECORDS}`
                            ? myTrainingActiveIcon
                            : myTrainingIcon
                        }
                      />
                      {sideMenu == false && (
                        <div
                          className={`${
                            path == `/${paths.TRAINING_RECORDS}`
                              ? "fw-bold v"
                              : ""
                          } pl-10 pr-20 text-overflow app-label`}
                        >
                          Training records
                        </div>
                      )}
                    </div>
                  </>
                ) : (
                  ""
                )}
                <div
                  className={`pt-10 pb-10 ${
                    path == `/${paths.REQUEST_STATUS}` ? "" : ""
                  } d-flex pl-60 cursor-pointer menuIcon`}
                  onClick={() => routeNavigation(`/${paths.REQUEST_STATUS}`)}
                >
                  <img
                    alt=""
                    src={
                      path == `/${paths.REQUEST_STATUS}`
                        ? requestStatusActiveIcon
                        : requestStatusIcon
                    }
                  />
                  {sideMenu == false && (
                    <div
                      className={`${
                        path == `/${paths.REQUEST_STATUS}` ? "fw-bold v" : ""
                      } pl-10 pr-20 text-overflow app-label`}
                    >
                      My request status
                    </div>
                  )}
                </div>
                <div
                  className={`pt-10 pb-10 ${
                    path == `/${paths.UPCOMING_TRAININGS}` ? "" : ""
                  } d-flex pl-60 cursor-pointer menuIcon`}
                  onClick={() =>
                    routeNavigation(`/${paths.UPCOMING_TRAININGS}`)
                  }
                >
                  <img
                    alt=""
                    src={
                      path == `/${paths.UPCOMING_TRAININGS}`
                        ? Companyside
                        : Company_side_inActive
                    }
                  />
                  {sideMenu == false && (
                    <div
                      className={`${
                        path == `/${paths.UPCOMING_TRAININGS}` ? "fw-bold" : ""
                      } pl-10 pr-20 text-overflow app-label`}
                    >
                      Company training calendar
                    </div>
                  )}
                </div>
                <div
                  className={`pt-10 pb-10 ${
                    path == `/${paths.COURSE_CATALOUGE}` ? "" : ""
                  } d-flex pl-60 cursor-pointer menuIcon`}
                  onClick={() => routeNavigation(`/${paths.COURSE_CATALOUGE}`)}
                >
                  <img
                    alt=""
                    src={
                      path == `/${paths.COURSE_CATALOUGE}`
                        ? Coursecatalogueactive
                        : Coursecatalogue
                    }
                  />
                  {sideMenu == false && (
                    <div
                      className={`${
                        path == `/${paths.COURSE_CATALOUGE}` ? "fw-bold " : ""
                      } pl-10 pr-20 text-overflow app-label`}
                    >
                      Course catalogue
                    </div>
                  )}
                </div>
                <div
                  className={`pt-10 pb-10 ${
                    path == `/${paths.SKILL_MATRIX}` ? "" : ""
                  } d-flex pl-60 cursor-pointer menuIcon`}
                  onClick={() => routeNavigation(`/${paths.SKILL_MATRIX}`)}
                >
                  <img
                    alt=""
                    src={
                      path == `/${paths.SKILL_MATRIX}`
                        ? Skillmatrixactive
                        : Skillmatrix
                    }
                  />
                  {sideMenu == false && (
                    <div
                      className={`${
                        path == `/${paths.SKILL_MATRIX}` ? "fw-bold " : ""
                      } pl-10 pr-20 text-overflow app-label`}
                    >
                      Capability chart
                    </div>
                  )}
                </div>
              </>
            ) : (
              <></>
            )}

            {UserRole.EMPLOYEE != Role ? (
              sideMenu === false ? (
                <div
                  className={` pt-10 pb-10 pl-20 ${
                    path == `/${paths.TEAM_TRAININGS}` ||
                    path == `/${paths.TEAM_SKILL_CHART}`
                      ? "sidebar-active pl-18"
                      : "pl-20"
                  } d-flex cursor-pointer menuIcon`}
                  onClick={() => {
                    setMyTeamOptions(!myTeamOptions);
                  }}
                >
                  <img
                    alt=""
                    src={
                      path == `/${paths.TEAM_TRAININGS}` ||
                      path == `/${paths.TEAM_SKILL_CHART}`
                        ? myteamactive
                        : myteam
                    }
                  />
                  {sideMenu == false && (
                    <div
                      className={`${
                        path == `/${paths.TEAM_TRAININGS}` ||
                        path == `/${paths.TEAM_SKILL_CHART}`
                          ? "fw-bold text-color-red"
                          : ""
                      } col-5 pl-20 text-overflow app-label`}
                    >
                      My team
                    </div>
                  )}
                  {myTeamOptions === true && sideMenu === false ? (
                    <div className="col-5 d-flex justify-content-end">
                      <img alt="" src={UpArrowIcon} className="setting-img" />
                    </div>
                  ) : myTeamOptions === false && sideMenu === false ? (
                    <div className="col-5 d-flex justify-content-end">
                      <img alt="" src={DownArrowIcon} className="setting-img" />
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
              ) : (
                <div
                  className={` pt-10 pb-10 pl-20 ${
                    path == `/${paths.TEAM_TRAININGS}` ||
                    path == `/${paths.TEAM_SKILL_CHART}`
                      ? "sidebar-active pl-18"
                      : "pl-20"
                  } d-flex cursor-pointer menuIcon`}
                  onClick={sideMenuClick}
                >
                  <img
                    alt=""
                    src={
                      path == `/${paths.TEAM_TRAININGS}` ||
                      path == `/${paths.TEAM_SKILL_CHART}`
                        ? myteamactive
                        : myteam
                    }
                  />
                </div>
              )
            ) : (
              <></>
            )}

            {sideMenu === false && myTeamOptions === true ? (
              <>
                <div
                  className={`pt-10 pb-10 ${
                    path == `/${paths.TEAM_TRAININGS}` ? "" : ""
                  } d-flex pl-60 cursor-pointer menuIcon`}
                  onClick={() => routeNavigation(`/${paths.TEAM_TRAININGS}`)}
                >
                  <img
                    alt=""
                    src={
                      path == `/${paths.TEAM_TRAININGS}`
                        ? teamtrainingActive
                        : teamtraining
                    }
                  />
                  {sideMenu == false && (
                    <div
                      className={`${
                        path == `/${paths.TEAM_TRAININGS}` ? "fw-bold" : ""
                      } pl-10 pr-20 text-overflow app-label`}
                    >
                      Team trainings
                    </div>
                  )}
                </div>
                <div
                  className={`pt-10 pb-10 ${
                    path == `/${paths.TEAM_SKILL_CHART}` ? "" : ""
                  } d-flex pl-60 cursor-pointer menuIcon`}
                  onClick={() => routeNavigation(`/${paths.TEAM_SKILL_CHART}`)}
                >
                  <img
                    alt=""
                    src={
                      path == `/${paths.TEAM_SKILL_CHART}`
                        ? skillActiveIcon
                        : skillIcon
                    }
                  />
                  {sideMenu == false && (
                    <div
                      className={`${
                        path == `/${paths.TEAM_SKILL_CHART}` ? "fw-bold" : ""
                      } pl-10 pr-20 text-overflow app-label`}
                    >
                      Team's capability chart
                    </div>
                  )}
                </div>
              </>
            ) : (
              <></>
            )}

            {UserRole.EMPLOYEE != Role ? (
              <div
                className={`${
                  sideMenu == true ? "pt-p8 pb-p8" : "pt-10 pb-10"
                } ${
                  path == `/${paths.SKILL_OVERVIEW}`
                    ? "sidebar-active pl-18"
                    : "pl-20"
                } d-flex  cursor-pointer menuIcon`}
                onClick={() => routeNavigation(`/${paths.SKILL_OVERVIEW}`)}
              >
                <img
                  src={
                    path == `/${paths.SKILL_OVERVIEW}`
                      ? skilloverviewactive
                      : skilloverview
                  }
                />
                {sideMenu == false && (
                  <div
                    className={`${
                      path == `/${paths.SKILL_OVERVIEW}`
                        ? "fw-bold text-color-red"
                        : ""
                    } pl-20 pr-20 text-overflow app-label`}
                  >
                    Capability overview
                  </div>
                )}
              </div>
            ) : (
              <></>
            )}

            {UserRole.ADMIN === Role || UserRole.SYSTEMADMIN === Role ? (
              sideMenu === false ? (
                <div
                  className={` pt-10 pb-10 pl-20 
                    ${
                      path == `/${paths.COURSE_MASTER}` ||
                      path == `/${paths.VENDORS}` ||
                      path == `/${paths.CATEGORY1}` ||
                      path == `/${paths.CATEGORY2}` ||
                      path == `/${paths.SKILLS}` ||
                      path == `/${paths.MAIN_ROLES}` ||
                      path == `/${paths.COMMITTEE_ROLES}` ||
                      path == `/${paths.GRADING}` ||
                      path == `/${paths.LEVEL}`
                        ? "sidebar-active pl-18"
                        : "pl-20"
                    } d-flex cursor-pointer menuIcon`}
                  onClick={() => {
                    setMasterDataOptions(!masterdataOptions);
                  }}
                >
                  <img
                    alt=""
                    src={
                      path == `/${paths.COURSE_MASTER}` ||
                      path == `/${paths.VENDORS}` ||
                      path == `/${paths.CATEGORY1}` ||
                      path == `/${paths.CATEGORY2}` ||
                      path == `/${paths.SKILLS}` ||
                      path == `/${paths.MAIN_ROLES}` ||
                      path == `/${paths.COMMITTEE_ROLES}` ||
                      path == `/${paths.GRADING}` ||
                      path == `/${paths.LEVEL}`
                        ? adminActive
                        : adminIcon
                    }
                  />
                  {sideMenu == false && (
                    <div
                      className={`
                    ${
                      path == `/${paths.COURSE_MASTER}` ||
                      path == `/${paths.VENDORS}` ||
                      path == `/${paths.CATEGORY1}` ||
                      path == `/${paths.CATEGORY2}` ||
                      path == `/${paths.SKILLS}` ||
                      path == `/${paths.MAIN_ROLES}` ||
                      path == `/${paths.COMMITTEE_ROLES}` ||
                      path == `/${paths.GRADING}` ||
                      path == `/${paths.LEVEL}`
                        ? "fw-bold text-color-red"
                        : ""
                    } col-5 pl-20 text-overflow app-label`}
                    >
                      Admin
                    </div>
                  )}{" "}
                  {masterdataOptions === true && sideMenu === false ? (
                    <div className="col-5 d-flex justify-content-end">
                      <img alt="" src={UpArrowIcon} className="setting-img" />
                    </div>
                  ) : masterdataOptions === false && sideMenu === false ? (
                    <div className="col-5 d-flex justify-content-end">
                      <img alt="" src={DownArrowIcon} className="setting-img" />
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
              ) : (
                <div
                  className={` pt-10 pb-10 pl-20 
                    ${
                      path == `/${paths.COURSE_MASTER}` ||
                      path == `/${paths.VENDORS}` ||
                      path == `/${paths.CATEGORY1}` ||
                      path == `/${paths.CATEGORY2}` ||
                      path == `/${paths.SKILLS}` ||
                      path == `/${paths.MAIN_ROLES}` ||
                      path == `/${paths.COMMITTEE_ROLES}` ||
                      path == `/${paths.LEVEL} ` ||
                      path == `/${paths.GRADING} ` ||
                      path == `/${paths.SKILLPROFICIENCYDURATION}`
                        ? "sidebar-active pl-18"
                        : "pl-20"
                    } d-flex cursor-pointer menuIcon`}
                  onClick={sideMenuClick}
                >
                  <img
                    alt=""
                    src={
                      path == `/${paths.COURSE_MASTER}` ||
                      path == `/${paths.VENDORS}` ||
                      path == `/${paths.CATEGORY1}` ||
                      path == `/${paths.CATEGORY2}` ||
                      path == `/${paths.SKILLS}` ||
                      path == `/${paths.MAIN_ROLES}` ||
                      path == `/${paths.GRADING}` ||
                      path == `/${paths.COMMITTEE_ROLES}` ||
                      path == `/${paths.LEVEL}`
                        ? adminActive
                        : adminIcon
                    }
                  />
                </div>
              )
            ) : (
              <></>
            )}

            {sideMenu === false && masterdataOptions === true ? (
              <>
                <div
                  className={`pt-10 pb-10 ${
                    path == `/${paths.COURSE_MASTER}` ? "" : ""
                  } d-flex pl-60 cursor-pointer menuIcon`}
                  onClick={() => routeNavigation(`/${paths.COURSE_MASTER}`)}
                >
                  <img
                    alt=""
                    src={
                      path == `/${paths.COURSE_MASTER}`
                        ? courseMasterActive
                        : courseMaster
                    }
                  />
                  {sideMenu == false && (
                    <div
                      className={`${
                        path == `/${paths.COURSE_MASTER}` ? "fw-bold" : ""
                      } pl-10 pr-20 text-overflow app-label`}
                    >
                      Course master
                    </div>
                  )}
                </div>
                <div
                  className={`pt-10 pb-10 ${
                    path == `/${paths.VENDORS}` ? "" : ""
                  } d-flex pl-60 cursor-pointer menuIcon`}
                  onClick={() => routeNavigation(`/${paths.VENDORS}`)}
                >
                  <img
                    alt=""
                    src={path == `/${paths.VENDORS}` ? Vendorsactive : Vendors}
                  />
                  {sideMenu == false && (
                    <div
                      className={`${
                        path == `/${paths.VENDORS}` ? "fw-bold" : ""
                      } pl-10 pr-20 text-overflow app-label`}
                    >
                      Vendors
                    </div>
                  )}
                </div>
                <div
                  className={`pt-10 pb-10 ${
                    path == `/${paths.CATEGORY1}` ? "" : ""
                  } d-flex pl-60 cursor-pointer menuIcon`}
                  onClick={() => routeNavigation(`/${paths.CATEGORY1}`)}
                >
                  <img
                    alt=""
                    src={
                      path == `/${paths.CATEGORY1}`
                        ? SubCategoryIconActive
                        : SubCategoryIcon
                    }
                  />
                  {sideMenu == false && (
                    <div
                      className={`${
                        path == `/${paths.CATEGORY1}` ? "fw-bold" : ""
                      } pl-10 pr-20 text-overflow app-label`}
                    >
                      Category 1
                    </div>
                  )}
                </div>
                <div
                  className={`pt-10 pb-10 ${
                    path == `/${paths.CATEGORY2}` ? "" : ""
                  } d-flex pl-60 cursor-pointer menuIcon`}
                  onClick={() => routeNavigation(`/${paths.CATEGORY2}`)}
                >
                  <img
                    alt=""
                    src={
                      path == `/${paths.CATEGORY2}`
                        ? SubCategoryIconActive
                        : SubCategoryIcon
                    }
                  />
                  {sideMenu == false && (
                    <div
                      className={`${
                        path == `/${paths.CATEGORY2}` ? "fw-bold" : ""
                      } pl-10 pr-20 text-overflow app-label`}
                    >
                      Category 2
                    </div>
                  )}
                </div>
                <div
                  className={`pt-10 pb-10 ${
                    path == `/${paths.SKILLS}` ? "" : ""
                  } d-flex pl-60 cursor-pointer menuIcon`}
                  onClick={() => routeNavigation(`/${paths.SKILLS}`)}
                >
                  <img
                    alt=""
                    src={
                      path == `/${paths.SKILLS}` ? skillActiveIcon : skillIcon
                    }
                  />
                  {sideMenu == false && (
                    <div
                      className={`${
                        path == `/${paths.SKILLS}` ? "fw-bold" : ""
                      } pl-10 pr-20 text-overflow app-label`}
                    >
                      Skills
                    </div>
                  )}
                </div>
                <div
                  className={`pt-10 pb-10 ${
                    path == `/${paths.GRADING}` ? "" : ""
                  } d-flex pl-60 cursor-pointer menuIcon`}
                  onClick={() => routeNavigation(`/${paths.GRADING}`)}
                >
                  <img
                    alt=""
                    src={
                      path == `/${paths.GRADING}` ? skillActiveIcon : skillIcon
                    }
                  />
                  {sideMenu == false && (
                    <div
                      className={`${
                        path == `/${paths.GRADING}` ? "fw-bold" : ""
                      } pl-10 pr-20 text-overflow app-label`}
                    >
                      Competency grading
                    </div>
                  )}
                </div>
                <div
                  className={`pt-10 pb-10 ${
                    path == `/${paths.LEVEL}` ? "" : ""
                  } d-flex pl-60 cursor-pointer menuIcon`}
                  onClick={() => routeNavigation(`/${paths.LEVEL}`)}
                >
                  <img
                    alt=""
                    src={path == `/${paths.LEVEL}` ? levelActive : levelIcon}
                  />
                  {sideMenu == false && (
                    <div
                      className={`${
                        path == `/${paths.LEVEL}` ? "fw-bold" : ""
                      } pl-10 pr-20 text-overflow app-label`}
                    >
                      Level
                    </div>
                  )}
                </div>
                <div
                  className={`pt-10 pb-10 ${
                    path == `/${paths.MAIN_ROLES}` ? "" : ""
                  } d-flex pl-60 cursor-pointer menuIcon`}
                  onClick={() => routeNavigation(`/${paths.MAIN_ROLES}`)}
                >
                  <img
                    alt=""
                    src={
                      path == `/${paths.MAIN_ROLES}`
                        ? supportingActiveIcon
                        : supportingIcon
                    }
                  />
                  {sideMenu == false && (
                    <div
                      className={`${
                        path == `/${paths.MAIN_ROLES}` ? "fw-bold" : ""
                      } pl-10 pr-20 text-overflow app-label`}
                    >
                      Main roles
                    </div>
                  )}
                </div>
                <div
                  className={`pt-10 pb-10 ${
                    path == `/${paths.COMMITTEE_ROLES}` ? "" : ""
                  } d-flex pl-60 cursor-pointer menuIcon`}
                  onClick={() => routeNavigation(`/${paths.COMMITTEE_ROLES}`)}
                >
                  <img
                    alt=""
                    src={
                      path == `/${paths.COMMITTEE_ROLES}`
                        ? supportingActiveIcon
                        : supportingIcon
                    }
                  />
                  {sideMenu == false && (
                    <div
                      className={`${
                        path == `/${paths.COMMITTEE_ROLES}` ? "fw-bold" : ""
                      } pl-10 pr-20 text-overflow app-label`}
                    >
                      Committee roles
                    </div>
                  )}
                </div>
                <div
                  className={`pt-10 pb-10 ${
                    path == `/${paths.SKILLPROFICIENCYDURATION}` ? "" : ""
                  } d-flex pl-60 cursor-pointer menuIcon`}
                  onClick={SkillProficiency}
                >
                  <img
                    alt=""
                    src={
                      path == `/${paths.SKILLPROFICIENCYDURATION}`
                        ? supportingActiveIcon
                        : supportingIcon
                    }
                  />
                  {sideMenu == false && (
                    <div
                      className={`${
                        path == `/${paths.SKILLPROFICIENCYDURATION}`
                          ? "fw-bold"
                          : "letter-assess"
                      } pl-10 pr-20 app-label`}
                    >
                      Competency assessment duration
                    </div>
                  )}
                </div>
              </>
            ) : (
              <></>
            )}
          </div>
        </>
      )}
      {isMobile == true && (
        <>
          <div className="row mobile-sidebar position-fixed">
            <div className="col-12">
              <img
                className="pl-20 pb-10 cursor-pointer pt-14"
                src={MenuIcon}
                onClick={() => {
                  setSideMenuMob(true);
                }}
              />
              <br />
            </div>
          </div>
        </>
      )}
      {isMobile == true && sideMenuMob == true && (
        <div
          className={`${
            sideMenuMob ? "sidebar-list" : "sidebar-list-close"
          } position-fixed side-scroll`}
          style={{ height: windowHeight - 1 }}
        >
          <img
            className="pl-20 pb-10 cursor-pointer pt-14"
            src={MenuIcon}
            onClick={() => {
              setSideMenuMob(false);
            }}
          />
          <br />

          {UserRole.EMPLOYEE === Role ? (
            <>
              <div
                className={`${"pt-10 pb-10"} ${
                  path == `/${paths.HOME}` ? "sidebar-active pl-17" : "pl-20"
                } d-flex cursor-pointer menuIcon`}
                onClick={() => routeNavigation(`/${paths.HOME}`)}
              >
                <img src={path == `/${paths.HOME}` ? HomeActive : Home} />
                {sideMenu == false && (
                  <div
                    className={`${
                      path == `/${paths.HOME}` ? "fw-bold" : ""
                    } pl-20 pr-20 text-overflow app-label`}
                  >
                    Home
                  </div>
                )}
              </div>
              <div
                className={`${"pt-10 pb-10"} ${
                  path == `/${paths.REQUEST_STATUS}`
                    ? "sidebar-active pl-17"
                    : "pl-20"
                } d-flex  cursor-pointer menuIcon`}
                onClick={() => routeNavigation(`/${paths.REQUEST_STATUS}`)}
              >
                <img
                  src={
                    path == `/${paths.REQUEST_STATUS}`
                      ? requestStatusActiveIcon
                      : requestStatusIcon
                  }
                />
                {sideMenu == false && (
                  <div
                    className={`${
                      path == `/${paths.REQUEST_STATUS}` ? "fw-bold" : ""
                    } pl-20 pr-20 text-overflow app-label`}
                  >
                    My request status
                  </div>
                )}
              </div>
              <div
                className={`${"pt-10 pb-10"} ${
                  path == `/${paths.TRAINING_CALENDER}`
                    ? "sidebar-active pl-17"
                    : "pl-20"
                } d-flex  cursor-pointer menuIcon`}
                onClick={() => routeNavigation(`/${paths.TRAINING_CALENDER}`)}
              >
                <img
                  src={
                    path == `/${paths.TRAINING_CALENDER}`
                      ? Companyside
                      : Company_side_inActive
                  }
                />
                {sideMenu == false && (
                  <div
                    className={`${
                      path == `/${paths.TRAINING_CALENDER}` ? "fw-bold" : ""
                    } pl-20 pr-20 text-overflow app-label`}
                  >
                    Company training calendar
                  </div>
                )}
              </div>
              <div
                className={`${"pt-10 pb-10"} ${
                  path == `/${paths.COURSE_CATALOUGE}`
                    ? "sidebar-active pl-17"
                    : "pl-20"
                } d-flex  cursor-pointer menuIcon`}
                onClick={() => routeNavigation(`/${paths.COURSE_CATALOUGE}`)}
              >
                <img
                  src={
                    path == `/${paths.COURSE_CATALOUGE}`
                      ? Coursecatalogueactive
                      : Coursecatalogue
                  }
                />
                {sideMenu == false && (
                  <div
                    className={`${
                      path == `/${paths.COURSE_CATALOUGE}` ? "fw-bold" : ""
                    } pl-20 pr-20 text-overflow app-label`}
                  >
                    Course catalouge
                  </div>
                )}
              </div>
              <div
                className={`${"pt-10 pb-10"} ${
                  path == `/${paths.SKILL_MATRIX}`
                    ? "sidebar-active pl-17"
                    : "pl-20"
                } d-flex  cursor-pointer menuIcon`}
                onClick={() => routeNavigation(`/${paths.SKILL_MATRIX}`)}
              >
                <img
                  src={
                    path == `/${paths.SKILL_MATRIX}`
                      ? Skillmatrixactive
                      : Skillmatrix
                  }
                />
                {sideMenu == false && (
                  <div
                    className={`${
                      path == `/${paths.SKILL_MATRIX}` ? "fw-bold" : ""
                    } pl-20 pr-20 text-overflow app-label`}
                  >
                    Capability chart
                  </div>
                )}
              </div>
            </>
          ) : (
            ""
          )}

          {UserRole.EMPLOYEE != Role ? (
            sideMenu === false ? (
              <div
                className={` pt-10 pb-10 pl-20 
                        ${
                          path == `/${paths.HOME}` ||
                          path == `/${paths.REQUEST_STATUS}` ||
                          path == `/${paths.TRAINING_RECORDS}` ||
                          path == `/${paths.UPCOMING_TRAININGS}` ||
                          path == `/${paths.SKILL_MATRIX}` ||
                          path == `/${paths.COURSE_CATALOUGE}`
                            ? "sidebar-active pl-16"
                            : "pl-20"
                        } d-flex cursor-pointer menuIcon`}
                onClick={() => {
                  setMySelfOptions(!mySelfOptions);
                }}
              >
                <img
                  alt=""
                  src={
                    path == `/${paths.HOME}` ||
                    path == `/${paths.REQUEST_STATUS}` ||
                    path == `/${paths.TRAINING_RECORDS}` ||
                    path == `/${paths.UPCOMING_TRAININGS}` ||
                    path == `/${paths.SKILL_MATRIX}` ||
                    path == `/${paths.COURSE_CATALOUGE}`
                      ? mySelfIconActive
                      : mySelfIcon
                  }
                />
                {sideMenu == false && (
                  <div
                    className={`
                        ${
                          path == `/${paths.HOME}` ||
                          path == `/${paths.REQUEST_STATUS}` ||
                          path == `/${paths.TRAINING_RECORDS}` ||
                          path == `/${paths.UPCOMING_TRAININGS}` ||
                          path == `/${paths.SKILL_MATRIX}` ||
                          path == `/${paths.COURSE_CATALOUGE}`
                            ? "fw-bold text-color-red"
                            : ""
                        } col-5 pl-20 text-overflow app-label`}
                  >
                    Myself
                  </div>
                )}
                {mySelfOptions === true && sideMenu === false ? (
                  <div className="col-5 d-flex justify-content-end">
                    <img alt="" src={UpArrowIcon} className="setting-img" />
                  </div>
                ) : mySelfOptions === false && sideMenu === false ? (
                  <div className="col-5 d-flex justify-content-end">
                    <img alt="" src={DownArrowIcon} className="setting-img" />
                  </div>
                ) : (
                  <></>
                )}
              </div>
            ) : (
              <div
                className={` pt-10 pb-10 pl-20 ${
                  path == `/${paths.HOME}` ||
                  path == `/${paths.REQUEST_STATUS}` ||
                  path == `/${paths.TRAINING_RECORDS}` ||
                  path == `/${paths.UPCOMING_TRAININGS}` ||
                  path == `/${paths.SKILL_MATRIX}` ||
                  path == `/${paths.COURSE_CATALOUGE}`
                    ? "sidebar-active pl-16"
                    : "pl-20"
                } d-flex cursor-pointer menuIcon`}
                onClick={sideMenuClick}
              >
                <img
                  alt=""
                  src={
                    path == `/${paths.HOME}` ||
                    path == `/${paths.REQUEST_STATUS}` ||
                    path == `/${paths.TRAINING_RECORDS}` ||
                    path == `/${paths.UPCOMING_TRAININGS}` ||
                    path == `/${paths.SKILL_MATRIX}` ||
                    path == `/${paths.COURSE_CATALOUGE}`
                      ? mySelfIconActive
                      : mySelfIcon
                  }
                />
              </div>
            )
          ) : (
            <></>
          )}

          {sideMenu === false && mySelfOptions === true ? (
            <>
              <div
                className={`pt-10 pb-10 ${
                  path == `/${paths.HOME}` ? "" : ""
                } d-flex pl-60 cursor-pointer`}
                onClick={() => routeNavigation(`/${paths.HOME}`)}
              >
                <img
                  alt=""
                  src={path == `/${paths.HOME}` ? HomeActive : Home}
                />
                {sideMenu == false && (
                  <div
                    className={`${
                      path == `/${paths.HOME}` ? "fw-bold" : ""
                    } pl-10 pr-20 text-overflow app-label`}
                  >
                    Home
                  </div>
                )}
              </div>
              {UserRole.ADMIN === Role || UserRole.SYSTEMADMIN === Role ? (
                <>
                  <div
                    className={`pt-10 pb-10 ${
                      path == `/${paths.TRAINING_RECORDS}` ? "" : ""
                    } d-flex pl-60 cursor-pointer menuIcon`}
                    onClick={() =>
                      routeNavigation(`/${paths.TRAINING_RECORDS}`)
                    }
                  >
                    <img
                      alt=""
                      src={
                        path == `/${paths.TRAINING_RECORDS}`
                          ? myTrainingActiveIcon
                          : myTrainingIcon
                      }
                    />
                    {sideMenu == false && (
                      <div
                        className={`${
                          path == `/${paths.TRAINING_RECORDS}` ? "fw-bold" : ""
                        } pl-10 pr-20 text-overflow app-label`}
                      >
                        Training records
                      </div>
                    )}
                  </div>
                </>
              ) : (
                ""
              )}
              <div
                className={`pt-10 pb-10 ${
                  path == `/${paths.REQUEST_STATUS}` ? "" : ""
                } d-flex pl-60 cursor-pointer menuIcon`}
                onClick={() => routeNavigation(`/${paths.REQUEST_STATUS}`)}
              >
                <img
                  alt=""
                  src={
                    path == `/${paths.REQUEST_STATUS}`
                      ? requestStatusActiveIcon
                      : requestStatusIcon
                  }
                />
                {sideMenu == false && (
                  <div
                    className={`${
                      path == `/${paths.REQUEST_STATUS}` ? "fw-bold" : ""
                    } pl-10 pr-20 text-overflow app-label`}
                  >
                    My request status
                  </div>
                )}
              </div>
              <div
                className={`pt-10 pb-10 ${
                  path == `/${paths.UPCOMING_TRAININGS}` ? "" : ""
                } d-flex pl-60 cursor-pointer menuIcon`}
                onClick={() => routeNavigation(`/${paths.UPCOMING_TRAININGS}`)}
              >
                <img
                  alt=""
                  src={
                    path == `/${paths.UPCOMING_TRAININGS}`
                      ? Companyside
                      : Company_side_inActive
                  }
                />
                {sideMenu == false && (
                  <div
                    className={`${
                      path == `/${paths.UPCOMING_TRAININGS}` ? "fw-bold" : ""
                    } pl-10 pr-20 text-overflow app-label`}
                  >
                    Company training calendar
                  </div>
                )}
              </div>
              <div
                className={`pt-10 pb-10 ${
                  path == `/${paths.COURSE_CATALOUGE}` ? "" : ""
                } d-flex pl-60 cursor-pointer menuIcon`}
                onClick={() => routeNavigation(`/${paths.COURSE_CATALOUGE}`)}
              >
                <img
                  alt=""
                  src={
                    path == `/${paths.COURSE_CATALOUGE}`
                      ? Coursecatalogueactive
                      : Coursecatalogue
                  }
                />
                {sideMenu == false && (
                  <div
                    className={`${
                      path == `/${paths.COURSE_CATALOUGE}` ? "fw-bold" : ""
                    } pl-10 pr-20 text-overflow app-label`}
                  >
                    Course catalogue
                  </div>
                )}
              </div>
              <div
                className={`pt-10 pb-10 ${
                  path == `/${paths.SKILL_MATRIX}` ? "" : ""
                } d-flex pl-60 cursor-pointer menuIcon`}
                onClick={() => routeNavigation(`/${paths.SKILL_MATRIX}`)}
              >
                <img
                  alt=""
                  src={
                    path == `/${paths.SKILL_MATRIX}`
                      ? Skillmatrixactive
                      : Skillmatrix
                  }
                />
                {sideMenu == false && (
                  <div
                    className={`${
                      path == `/${paths.SKILL_MATRIX}` ? "fw-bold" : ""
                    } pl-10 pr-20 text-overflow app-label`}
                  >
                    Capability chart
                  </div>
                )}
              </div>
            </>
          ) : (
            <></>
          )}
          {UserRole.EMPLOYEE != Role ? (
            sideMenu === false ? (
              <div
                className={` pt-10 pb-10 pl-20 
                        ${
                          path == `/${paths.TEAM_TRAININGS}` ||
                          path == `/${paths.TEAM_SKILL_CHART}`
                            ? "sidebar-active pl-18"
                            : "pl-20"
                        } d-flex cursor-pointer menuIcon`}
                onClick={() => {
                  setMyTeamOptions(!myTeamOptions);
                }}
              >
                <img
                  alt=""
                  src={
                    path == `/${paths.TEAM_TRAININGS}` ||
                    path == `/${paths.TEAM_SKILL_CHART}`
                      ? myteamactive
                      : myteam
                  }
                />
                {sideMenu == false && (
                  <div
                    className={`
                        ${
                          path == `/${paths.TEAM_TRAININGS}` ||
                          path == `/${paths.TEAM_SKILL_CHART}`
                            ? "fw-bold text-color-red"
                            : ""
                        } col-5 pl-20 text-overflow app-label`}
                  >
                    My team
                  </div>
                )}
                {myTeamOptions === true && sideMenu === false ? (
                  <div className="col-5 d-flex justify-content-end">
                    <img alt="" src={UpArrowIcon} className="setting-img" />
                  </div>
                ) : myTeamOptions === false && sideMenu === false ? (
                  <div className="col-5 d-flex justify-content-end">
                    <img alt="" src={DownArrowIcon} className="setting-img" />
                  </div>
                ) : (
                  <></>
                )}
              </div>
            ) : (
              <div
                className={` pt-10 pb-10 pl-20 ${
                  path == `/${paths.TEAM_TRAININGS}` ||
                  path == `/${paths.TEAM_SKILL_CHART}`
                    ? "sidebar-active pl-18"
                    : "pl-20"
                } d-flex cursor-pointer menuIcon`}
                onClick={sideMenuClick}
              >
                <img
                  alt=""
                  src={
                    path == `/${paths.TEAM_TRAININGS}` ||
                    path == `/${paths.TEAM_SKILL_CHART}`
                      ? myteamactive
                      : myteam
                  }
                />
              </div>
            )
          ) : (
            <></>
          )}

          {sideMenu === false && myTeamOptions === true ? (
            <>
              <div
                className={`pt-10 pb-10 ${
                  path == `/${paths.TEAM_TRAININGS}` ? "" : ""
                } d-flex pl-60 cursor-pointer menuIcon`}
                onClick={() => routeNavigation(`/${paths.TEAM_TRAININGS}`)}
              >
                <img
                  alt=""
                  src={
                    path == `/${paths.TEAM_TRAININGS}`
                      ? teamtrainingActive
                      : teamtraining
                  }
                />
                {sideMenu == false && (
                  <div
                    className={`${
                      path == `/${paths.TEAM_TRAININGS}` ? "fw-bold" : ""
                    } pl-10 pr-20 text-overflow app-label`}
                  >
                    Team trainings
                  </div>
                )}
              </div>
              <div
                className={`pt-10 pb-10 ${
                  path == `/${paths.TEAM_SKILL_CHART}` ? "" : ""
                } d-flex pl-60 cursor-pointer menuIcon`}
                onClick={() => routeNavigation(`/${paths.TEAM_SKILL_CHART}`)}
              >
                <img
                  alt=""
                  src={
                    path == `/${paths.TEAM_SKILL_CHART}`
                      ? skillActiveIcon
                      : skillIcon
                  }
                />
                {sideMenu == false && (
                  <div
                    className={`${
                      path == `/${paths.TEAM_SKILL_CHART}` ? "fw-bold" : ""
                    } pl-10 pr-20 text-overflow app-label`}
                  >
                    Team's capability chart
                  </div>
                )}
              </div>
            </>
          ) : (
            <></>
          )}

          {UserRole.EMPLOYEE != Role ? (
            <div
              className={`${sideMenu == true ? "pt-p8 pb-p8" : "pt-10 pb-10"} ${
                path == `/${paths.SKILL_OVERVIEW}`
                  ? "sidebar-active pl-18"
                  : "pl-20"
              } d-flex  cursor-pointer menuIcon`}
              onClick={() => routeNavigation(`/${paths.SKILL_OVERVIEW}`)}
            >
              <img
                src={
                  path == `/${paths.SKILL_OVERVIEW}`
                    ? skilloverviewactive
                    : skilloverview
                }
              />
              {sideMenu == false && (
                <div
                  className={`${
                    path == `/${paths.SKILL_OVERVIEW}`
                      ? "fw-bold text-color-red"
                      : ""
                  } pl-20 pr-20 text-overflow app-label`}
                >
                  Capability overview
                </div>
              )}
            </div>
          ) : (
            <></>
          )}

          {UserRole.ADMIN === Role || UserRole.SYSTEMADMIN === Role ? (
            sideMenu === false ? (
              <div
                className={` pt-10 pb-10 pl-20 
                    ${
                      path == `/${paths.COURSE_MASTER}` ||
                      path == `/${paths.VENDORS}` ||
                      path == `/${paths.CATEGORY1}` ||
                      path == `/${paths.CATEGORY2}` ||
                      path == `/${paths.SKILLS}` ||
                      path == `/${paths.MAIN_ROLES}` ||
                      path == `/${paths.COMMITTEE_ROLES}` ||
                      path == `/${paths.LEVEL}` ||
                      path == `/${paths.SKILLPROFICIENCYDURATION}`
                        ? "sidebar-active pl-18"
                        : "pl-20"
                    } d-flex cursor-pointer menuIcon`}
                onClick={() => {
                  setMasterDataOptions(!masterdataOptions);
                }}
              >
                <img
                  alt=""
                  src={
                    path == `/${paths.COURSE_MASTER}` ||
                    path == `/${paths.VENDORS}` ||
                    path == `/${paths.CATEGORY1}` ||
                    path == `/${paths.CATEGORY2}` ||
                    path == `/${paths.SKILLS}` ||
                    path == `/${paths.MAIN_ROLES}` ||
                    path == `/${paths.COMMITTEE_ROLES}` ||
                    path == `/${paths.LEVEL}`
                      ? adminActive
                      : adminIcon
                  }
                />
                {sideMenu == false && (
                  <div
                    className={`
                    ${
                      path == `/${paths.COURSE_MASTER}` ||
                      path == `/${paths.VENDORS}` ||
                      path == `/${paths.CATEGORY1}` ||
                      path == `/${paths.CATEGORY2}` ||
                      path == `/${paths.SKILLS}` ||
                      path == `/${paths.MAIN_ROLES}` ||
                      path == `/${paths.COMMITTEE_ROLES}` ||
                      path == `/${paths.LEVEL}` ||
                      path == `/${paths.SKILLPROFICIENCYDURATION}`
                        ? "fw-bold text-color-red"
                        : ""
                    } col-5 pl-20 text-overflow app-label`}
                  >
                    Admin
                  </div>
                )}{" "}
                {masterdataOptions === true && sideMenu === false ? (
                  <div className="col-5 d-flex justify-content-end">
                    <img alt="" src={UpArrowIcon} className="setting-img" />
                  </div>
                ) : masterdataOptions === false && sideMenu === false ? (
                  <div className="col-5 d-flex justify-content-end">
                    <img alt="" src={DownArrowIcon} className="setting-img" />
                  </div>
                ) : (
                  <></>
                )}
              </div>
            ) : (
              <div
                className={` pt-10 pb-10 pl-20 
                    ${
                      path == `/${paths.COURSE_MASTER}` ||
                      path == `/${paths.VENDORS}` ||
                      path == `/${paths.CATEGORY1}` ||
                      path == `/${paths.CATEGORY2}` ||
                      path == `/${paths.SKILLS}` ||
                      path == `/${paths.MAIN_ROLES}` ||
                      path == `/${paths.COMMITTEE_ROLES}` ||
                      path == `/${paths.LEVEL}` ||
                      path == `/${path.SKILLPROFICIENCYDURATION}`
                        ? "sidebar-active pl-18"
                        : "pl-20"
                    } d-flex cursor-pointer menuIcon`}
                onClick={sideMenuClick}
              >
                <img
                  alt=""
                  src={
                    path == `/${paths.COURSE_MASTER}` ||
                    path == `/${paths.VENDORS}` ||
                    path == `/${paths.CATEGORY1}` ||
                    path == `/${paths.CATEGORY2}` ||
                    path == `/${paths.SKILLS}` ||
                    path == `/${paths.MAIN_ROLES}` ||
                    path == `/${paths.COMMITTEE_ROLES}` ||
                    path == `/${paths.LEVEL}` ||
                    path == `/${paths.SKILLPROFICIENCYDURATION}`
                      ? adminActive
                      : adminIcon
                  }
                />
              </div>
            )
          ) : (
            <></>
          )}

          {sideMenu === false && masterdataOptions === true ? (
            <>
              <div
                className={`pt-10 pb-10 ${
                  path == `/${paths.COURSE_MASTER}` ? "" : ""
                } d-flex pl-60 cursor-pointer menuIcon`}
                onClick={() => routeNavigation(`/${paths.COURSE_MASTER}`)}
              >
                <img
                  alt=""
                  src={
                    path == `/${paths.COURSE_MASTER}`
                      ? courseMasterActive
                      : courseMaster
                  }
                />
                {sideMenu == false && (
                  <div
                    className={`${
                      path == `/${paths.COURSE_MASTER}` ? "fw-bold" : ""
                    } pl-10 pr-20 text-overflow app-label`}
                  >
                    Course master
                  </div>
                )}
              </div>
              <div
                className={`pt-10 pb-10 ${
                  path == `/${paths.VENDORS}` ? "" : ""
                } d-flex pl-60 cursor-pointer menuIcon`}
                onClick={() => routeNavigation(`/${paths.VENDORS}`)}
              >
                <img
                  alt=""
                  src={path == `/${paths.VENDORS}` ? Vendorsactive : Vendors}
                />
                {sideMenu == false && (
                  <div
                    className={`${
                      path == `/${paths.VENDORS}` ? "fw-bold" : ""
                    } pl-10 pr-20 text-overflow app-label`}
                  >
                    Vendors
                  </div>
                )}
              </div>
              <div
                className={`pt-10 pb-10 ${
                  path == `/${paths.CATEGORY1}` ? "" : ""
                } d-flex pl-60 cursor-pointer menuIcon`}
                onClick={() => routeNavigation(`/${paths.CATEGORY1}`)}
              >
                <img
                  alt=""
                  src={
                    path == `/${paths.CATEGORY1}`
                      ? SubCategoryIconActive
                      : SubCategoryIcon
                  }
                />
                {sideMenu == false && (
                  <div
                    className={`${
                      path == `/${paths.CATEGORY1}` ? "fw-bold" : ""
                    } pl-10 pr-20 text-overflow app-label`}
                  >
                    Category 1
                  </div>
                )}
              </div>
              <div
                className={`pt-10 pb-10 ${
                  path == `/${paths.CATEGORY2}` ? "" : ""
                } d-flex pl-60 cursor-pointer menuIcon`}
                onClick={() => routeNavigation(`/${paths.CATEGORY2}`)}
              >
                <img
                  alt=""
                  src={
                    path == `/${paths.CATEGORY2}`
                      ? SubCategoryIconActive
                      : SubCategoryIcon
                  }
                />
                {sideMenu == false && (
                  <div
                    className={`${
                      path == `/${paths.CATEGORY2}` ? "fw-bold" : ""
                    } pl-10 pr-20 text-overflow app-label`}
                  >
                    Category 2
                  </div>
                )}
              </div>
              <div
                className={`pt-10 pb-10 ${
                  path == `/${paths.SKILLS}` ? "" : ""
                } d-flex pl-60 cursor-pointer menuIcon`}
                onClick={() => routeNavigation(`/${paths.SKILLS}`)}
              >
                <img
                  alt=""
                  src={path == `/${paths.SKILLS}` ? skillActiveIcon : skillIcon}
                />
                {sideMenu == false && (
                  <div
                    className={`${
                      path == `/${paths.SKILLS}` ? "fw-bold" : ""
                    } pl-10 pr-20 text-overflow app-label`}
                  >
                    Skills
                  </div>
                )}
              </div>
              <div
                className={`pt-10 pb-10 ${
                  path == `/${paths.GRADING}` ? "" : ""
                } d-flex pl-60 cursor-pointer menuIcon`}
                onClick={() => routeNavigation(`/${paths.GRADING}`)}
              >
                <img
                  alt=""
                  src={path == `/${paths.GRADING}` ? skillActiveIcon : skillIcon}
                />
                {sideMenu == false && (
                  <div
                    className={`${
                      path == `/${paths.GRADING}` ? "fw-bold" : ""
                    } pl-10 pr-20 text-overflow app-label`}
                  >
                    Competency grading
                  </div>
                )}
              </div>
              <div
                className={`pt-10 pb-10 ${
                  path == `/${paths.LEVEL}` ? "" : ""
                } d-flex pl-60 cursor-pointer menuIcon`}
                onClick={() => routeNavigation(`/${paths.LEVEL}`)}
              >
                <img
                  alt=""
                  src={path == `/${paths.LEVEL}` ? levelActive : levelIcon}
                />
                {sideMenu == false && (
                  <div
                    className={`${
                      path == `/${paths.LEVEL}` ? "fw-bold" : ""
                    } pl-10 pr-20 text-overflow app-label`}
                  >
                    Level
                  </div>
                )}
              </div>
              <div
                className={`pt-10 pb-10 ${
                  path == `/${paths.MAIN_ROLES}` ? "" : ""
                } d-flex pl-60 cursor-pointer menuIcon`}
                onClick={() => routeNavigation(`/${paths.MAIN_ROLES}`)}
              >
                <img
                  alt=""
                  src={
                    path == `/${paths.MAIN_ROLES}`
                      ? supportingActiveIcon
                      : supportingIcon
                  }
                />
                {sideMenu == false && (
                  <div
                    className={`${
                      path == `/${paths.MAIN_ROLES}` ? "fw-bold" : ""
                    } pl-10 pr-20 text-overflow app-label`}
                  >
                    Main roles
                  </div>
                )}
              </div>
              <div
                className={`pt-10 pb-10 ${
                  path == `/${paths.COMMITTEE_ROLES}` ? "" : ""
                } d-flex pl-60 cursor-pointer menuIcon`}
                onClick={() => routeNavigation(`/${paths.COMMITTEE_ROLES}`)}
              >
                <img
                  alt=""
                  src={
                    path == `/${paths.COMMITTEE_ROLES}`
                      ? supportingActiveIcon
                      : supportingIcon
                  }
                />
                {sideMenu == false && (
                  <div
                    className={`${
                      path == `/${paths.COMMITTEE_ROLES}` ? "fw-bold" : ""
                    } pl-10 pr-20 text-overflow app-label`}
                  >
                    Committee roles
                  </div>
                )}
              </div>
              <div
                className={`pt-10 pb-10 ${
                  path == `/${paths.SKILLPROFICIENCYDURATION}` ? "" : ""
                } d-flex pl-60 cursor-pointer menuIcon`}
                onClick={() =>
                  routeNavigation(`/${paths.SKILLPROFICIENCYDURATION}`)
                }
              >
                <img
                  alt=""
                  src={
                    path == `/${paths.SKILLPROFICIENCYDURATION}`
                      ? supportingActiveIcon
                      : supportingIcon
                  }
                />
                {sideMenu == false && (
                  <div
                    className={`${
                      path == `/${paths.SKILLPROFICIENCYDURATION}`
                        ? "fw-bold"
                        : "letter-assess"
                    } pl-10 pr-20 app-label`}
                  >
                    Competency assessment duration
                  </div>
                )}
              </div>
            </>
          ) : (
            <></>
          )}
        </div>
      )}
      {/* ************ Notification Canvas *************** */}
      <div
        className="offcanvas offcanvas-end offcanvasStyle notification-zindex"
        tabIndex={-1}
        data-bs-scroll="false"
        data-bs-backdrop="false"
        id="NotificationScreen"
        aria-labelledby="offcanvasScrollingLabel"
      >
        {propertyLoader && (
          <div className="loader-new-1">
            <PulseLoader color="#D12232" size={10} speedMultiplier={1} />
          </div>
        )}
        {propertyFailed && (
          <div className="loader-new-1">
            <span>Loading failed</span>
          </div>
        )}

        <div className="offcanvas-header offcanvas-header2 px-4 pt-4">
          <div className="NotifyHead">
            <h6 id="offcanvasRightLabel" className="modal-title head-span">
              Notifications
            </h6>

            <button
              className={`text-reset offcavasclose buttonstyle`}
              style={{ backgroundColor: "white" }}
              onClick={() => {
                closeNotify();
              }}
            >
              <CommonIcon
                fileName="CrossIcon"
                className="cursor-pointer app-image-hover"
              />
            </button>
          </div>

          <div className="notifyBtnBox mt-3">
            {messages?.length > 0 && (
              <div className="mr-2">
                <div className="viewButton">
                  <CommonIcon fileName="notifyActive" />
                  <span onClick={() => removeNotification(1, "clearAll")}>
                    Clear all
                  </span>
                </div>
              </div>
            )}
          </div>
        </div>

        <div className="offcanvas-body px-4 pt-0">
          <div className="viewMain viewNofity">
            {messages && messages?.length > 0
              ? messages?.map((msg, index) => {
                  return (
                    <div className="notifySection mt-3" key={index}>
                      <div className="notifyMsg">
                        <div className="row">
                          <div className="col-6 font-weight-bold">
                            {msg.trainingRequestId
                              ? msg.trainingRequestId
                              : "-"}
                          </div>
                          <div
                            className="col-6 text-right cursor-pointer"
                            onClick={() =>
                              removeNotification(msg.notificationId, "clearOne")
                            }
                          >
                            ✕
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-6">
                            {msg.courseTitle ? msg.courseTitle : "-"}
                          </div>
                          <div className="col-6 text-right">
                            {msg.createdTime}
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-8">
                            {msg.body ? msg.body : "-"}
                          </div>
                          <div className="col-4 text-right">
                            {msg.createdDate
                              ? moment(msg.createdDate).format("DD-MMM-YYYY")
                              : "-"}
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })
              : messages && (
                  <div style={{ textAlign: "center", marginTop: "120px" }}>
                    <img
                      alt="No notification"
                      src={noNotify}
                      width={230}
                      style={{ opacity: 0.2 }}
                    />
                  </div>
                )}
          </div>
        </div>
      </div>

      {/* Logout model */}

      <div
        className="modal fade modal-style"
        id="logoutPage"
        tabIndex={-1}
        role="dialog"
        aria-labelledby="exampleModalCenterTitle"
        aria-hidden="true"
      >
        <div
          className="modal-dialog modal-dialog-centered modal-lg"
          role="document"
        >
          <div className="modal-content">
            <div className="modal-header pb-2 pl-20">
              <h5
                className="modal-title d-flex pl-10"
                id="exampleModalLongTitle"
              >
                <img alt="" src={logoutimage} />
                &nbsp;<span className="mt-1 pl-5"></span>Logout
              </h5>
            </div>
            <div className="modal-body pl-20">
              <h5 className="warning-text">
                Are you sure you want to log out?
              </h5>
            </div>
            <div className="modal-footer border-top-none justify-content-center pb-3">
              <button
                className={`btn btn-light input-group  d-flex ${
                  isMobile ? "warning-btn-mobile" : "warning-btn"
                } p-1`}
                data-bs-dismiss="modal"
              >
                <span className="rejectedstatus-color text-color-red pl-10">
                  No
                </span>{" "}
              </button>
              <button
                onClick={LogoutYes}
                className={`btn btn-light input-group d-flex ${
                  isMobile ? "filter-nextMobilebtn" : "filter-nextbtn"
                }`}
                data-bs-dismiss="modal"
              >
                <span className="model-label pl-10">Yes</span>{" "}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TopBar;
